var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnlockingImg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 96,
    height: 96,
    rx: 24,
    fill: "#EEF6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 56L68 56C68.8284 56 69.5 55.3284 69.5 54.5V33.5C69.5 32.6716 68.8284 32 68 32H29C28.1716 32 27.5 32.6716 27.5 33.5V54.5C27.5 55.3284 28.1716 56 29 56Z",
    stroke: "#008CB7",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 60.5H66.5M33.5 65H63.5",
    stroke: "#008CB7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 51.5C52.6421 51.5 56 48.1421 56 44C56 39.8579 52.6421 36.5 48.5 36.5C44.3579 36.5 41 39.8579 41 44C41 48.1421 44.3579 51.5 48.5 51.5Z",
    stroke: "#008CB7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5 39.5C67.5109 39.5 65.6032 38.7098 64.1967 37.3033C62.7902 35.8968 62 33.9891 62 32M27.5 39.5C28.4849 39.5 29.4602 39.306 30.3701 38.9291C31.2801 38.5522 32.1069 37.9997 32.8033 37.3033C33.4997 36.6069 34.0522 35.7801 34.4291 34.8701C34.806 33.9602 35 32.9849 35 32M69.5 48.5C67.5109 48.5 65.6032 49.2902 64.1967 50.6967C62.7902 52.1032 62 54.0109 62 56M27.5 48.5C28.4849 48.5 29.4602 48.694 30.3701 49.0709C31.2801 49.4478 32.1069 50.0003 32.8033 50.6967C33.4997 51.3931 34.0522 52.2199 34.4291 53.1299C34.806 54.0398 35 55.0151 35 56",
    stroke: "#008CB7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockingImg3);
export default __webpack_public_path__ + "static/media/UnlockingImg3.22e284a2a76fea67262d6c9539372eff.svg";
export { ForwardRef as ReactComponent };